import React from "react";
import { Select } from "antd";
import { ButtonEdit } from "../../../../common/Buttons";
import TextInputModal from "../../../../common/TextInputModal";
import DataPickerInputModal from "../../../../common/DataPickerInputModal";
import {
  LabelTextStyle,
  RadiusCheckBox,
} from "../../../../common/StyledComponents";
import { getDateFormat } from "../../../../../helpers/Utils";
import moment from "moment";
import AutoFillComponent from "../../../../common/AutoFillComponent";
const { Option } = Select;

function ServiceFormChildren1({
  form,
  onChangeHandler,
  onSelectType,
  errors,
  searching,
}) {
  function disabledDate(current) {
    return current > moment().endOf("day");
  }

  const pirkimoData = () => {
    return (
      <>
        <DataPickerInputModal
          disabledDate={disabledDate}
          text="Date of purchase"
          name="buy_date"
          value={getDateFormat(form.buy_date)}
          // value={moment(form.buy_date)}
          onChange={(_, r) =>
            onChangeHandler({ target: { name: "buy_date", value: r } }, "form")
          }
          warning={errors.buy_date}
        />
      </>
    );
  };
  // const pirkimo_dokumentas = () => {
  //   return (
  //     <TextInputModal
  //       required={true}
  //       text="Pirkimo dokumentas"
  //       name="buy_document"
  //       value={form.buy_document}
  //       onChange={(e) => onChangeHandler(e, "form")}
  //       warning={errors.buy_document}
  //     />
  //   );
  // };
  const dokumento_tipas = () => {
    return (
      <>
        <div className={"text-bold my-1"}>
          Document type <span className="orange_color">*</span>
        </div>
        <Select
          name="document_type"
          className={`${errors.document_type ? "error_border" : ""}`}
          value={form.document_type || undefined}
          style={{ width: "100%" }}
          placeholder="Choose"
          onChange={(value) =>
            onChangeHandler(
              { target: { name: "document_type", value } },
              "form"
            )
          }
        >
          <Option value="invoice">Invoice</Option>
          <Option value="cheque">Cheque</Option>
          <Option value="order">Order</Option>
        </Select>
        {errors.document_type && (
          <div className="text-danger">{errors.document_type}</div>
        )}
      </>
    );
  };

  const sertifikato_data = () => {
    return (
      <>
        <DataPickerInputModal
          required={true}
          disabledDate={disabledDate}
          text="Date of certificate"
          name="certificate_date"
          value={getDateFormat(form.certificate_date)}
          onChange={(_, ar) =>
            onChangeHandler(
              { target: { name: "certificate_date", value: ar } },
              "form"
            )
          }
          warning={errors.certificate_date}
        />
      </>
    );
  };
  const prekes_kodas = () => {
    return (
      <TextInputModal
        required={true}
        text="Product code"
        name="item_code"
        value={form.item_code}
        onChange={(e) => onChangeHandler(e, "form")}
        warning={errors.item_code}
      />
    );
  };
  const setifikato_numeris = () => {
    return (
      <TextInputModal
        required={true}
        text="Certificate number"
        name="certificate_number"
        value={form.certificate_number}
        onChange={(e, ar) => onChangeHandler(e, "form")}
        warning={errors.certificate_number}
      />
    );
  };
  const pvm_sask = () => {
    return (
      <TextInputModal
        text="VAT Invoice"
        name="form_pvm"
        value={form.form_pvm}
        onChange={(e) => onChangeHandler(e, "form")}
        warning={errors.form_pvm}
      />
    );
  };
  const paieska = () => {
    return (
      <>
        <div className="text-bold my-1 invisible">Search..</div>
        <div className="d-flex justify-content-end">
          <ButtonEdit
            disabled={searching}
            style={{
              width: "32px",
              height: "32px",
              backgroundColor: "#f7931e",
            }}
            onEdit={() => onSelectType()}
          />
        </div>
      </>
    );
  };

  const invoice_items = () => {
    return (
      <TextInputModal
        required={true}
        text="Invoice number"
        name="buy_document"
        value={form.buy_document}
        onChange={(e) =>
          onChangeHandler(
            {
              target: {
                name: e.target.name,
                value: e.target.value.toUpperCase(),
              },
            },
            "form"
          )
        }
        warning={errors.buy_document}
      />
    );
  };

  const cheque_items = () => {
    return (
      <TextInputModal
        required={true}
        text="Cheque number"
        name="buy_document"
        value={form.buy_document}
        onChange={(e) =>
          onChangeHandler(
            {
              target: {
                name: e.target.name,
                value: e.target.value.toUpperCase(),
              },
            },
            "form"
          )
        }
        warning={errors.buy_document}
      />
    );
  };

  const item_name = () => {
    return (
      <TextInputModal
        required={true}
        text="Product name"
        name="item_name"
        onChange={(e) => onChangeHandler(e, "form")}
        value={form.item_name}
        warning={errors.item_name}
      />
    );
  };

  const serial_number = () => {
    return (
      <TextInputModal
        text="Serial number"
        name="serial_number"
        onChange={(e) =>
          onChangeHandler(
            {
              target: {
                name: e.target.name,
                value: e.target.value.toUpperCase(),
              },
            },
            "form"
          )
        }
        value={form.serial_number}
        warning={errors.serial_number}
      />
    );
  };

  const formBuilder = () => {
    switch (form.type) {
      case "Warranty":
        return (
          <>
            <div className="pr-2" style={{ width: "32%" }}>
              {pirkimoData()}
            </div>
            <div className="px-2" style={{ width: "32%" }}>
              {dokumento_tipas()}
            </div>
            <div className="px-2" style={{ width: "32%" }}>
              {form.document_type === "cheque" ? (
                cheque_items()
              ) : form.document_type === "invoice" ? (
                invoice_items()
              ) : form.document_type === "order" ? (
                <SearchOrderInput
                  value={form.order_id}
                  onChange={(value) =>
                    onChangeHandler(
                      {
                        target: {
                          name: "order_id",
                          value,
                        },
                      },
                      "form"
                    )
                  }
                />
              ) : null}
            </div>
            <div className="pl-2" style={{ width: "4%" }}>
              {form.document_type && paieska()}
            </div>
          </>
        );
      case "Non-warranty":
        return (
          <>
            <div className="pr-2" style={{ width: "32%" }}>
              {pirkimoData()}
            </div>
            <div className="px-2" style={{ width: "32%" }}>
              {dokumento_tipas()}
            </div>
            <div className="px-2" style={{ width: "32%" }}>
              {form.document_type === "cheque" ? (
                cheque_items()
              ) : form.document_type === "invoice" ? (
                invoice_items()
              ) : form.document_type === "order" ? (
                <SearchOrderInput
                  value={form.order_id}
                  onChange={(value) =>
                    onChangeHandler(
                      {
                        target: {
                          name: "order_id",
                          value,
                        },
                      },
                      "form"
                    )
                  }
                />
              ) : null}
            </div>
            <div className="pl-2" style={{ width: "4%" }}>
              {form.document_type && paieska()}
            </div>
          </>
        );
      case "Defect act":
        return (
          <>
            <div className="pr-2" style={{ width: "32%" }}>
              {pirkimoData()}
            </div>
            <div className="px-2" style={{ width: "32%" }}>
              {dokumento_tipas()}
            </div>
            <div className="px-2" style={{ width: "32%" }}>
              {form.document_type === "cheque" ? (
                cheque_items()
              ) : form.document_type === "invoice" ? (
                invoice_items()
              ) : form.document_type === "order" ? (
                <SearchOrderInput
                  value={form.order_id}
                  onChange={(value) =>
                    onChangeHandler(
                      {
                        target: {
                          name: "order_id",
                          value,
                        },
                      },
                      "form"
                    )
                  }
                />
              ) : null}
            </div>
            <div className="pl-2" style={{ width: "4%" }}>
              {form.document_type && paieska()}
            </div>
          </>
        );
      case "PPG":
        return (
          <>
            <div className="pr-2" style={{ width: "32%" }}>
              {sertifikato_data()}
            </div>
            <div className="px-2" style={{ width: "32%" }}>
              {setifikato_numeris()}
            </div>
            <div className="pl-2" style={{ width: "4%" }}>
              {paieska()}
            </div>
          </>
        );
      case "Pre-trade":
        return (
          <>
            <div className="pr-2" style={{ width: "32%" }}>
              {prekes_kodas()}
            </div>
            <div className="px-2" style={{ width: "32%" }}>
              {pvm_sask()}
            </div>
            <div className="pl-2" style={{ width: "4%" }}>
              {paieska()}
            </div>
          </>
        );

      default:
        return <div>Loading...</div>;
    }
  };

  const onSelectItem = (i) => {
    onChangeHandler(
      { target: { name: "item_price", value: i.price } },
      "form",
      i
    );
  };

  return (
    <>
      <div>
        <div className="row mx-0">{formBuilder()}</div>
      </div>
      {form.goods.length > 0 && (
        <div className="my-3">
          <LabelTextStyle className={!form.item_name ? "text-danger" : ""}>
            Select a product
          </LabelTextStyle>
          <div style={{ width: "33%" }}>
            <table className="table table-sm">
              <tbody>
                {form.goods.map((i, index) => (
                  <tr key={index}>
                    <td style={{ width: 25 }}>
                      <RadiusCheckBox
                        checked={form.item_name === i.title}
                        onChange={() => onSelectItem(i)}
                      />
                    </td>
                    <td>{i.title}</td>
                    <td>
                      {i.price}
                      {" Eur."}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div style={{ width: "75%" }}>
              <TextInputModal
                text="Serial number"
                name="serial_number"
                value={form.serial_number}
                onChange={(e) =>
                  onChangeHandler(
                    {
                      target: {
                        name: e.target.name,
                        value: e.target.value.toUpperCase(),
                      },
                    },
                    "form"
                  )
                }
                warning={errors.serial_number}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

const SearchOrderInput = ({ onChange, value }) => {
  const renderSearchEndPoint = (value) => {
    return `/api/v1/orders/search_orders_options?q[id_or_id_order_start]=${value}`;
  };

  const ArrayBuilder = (arr) => {
    const responseBuild = arr.map((e) => ({
      label: e[1],
      value: e[0],
    }));
    return responseBuild;
  };
  
  return (
    <AutoFillComponent
      required={true}
      label={"Order no."}
      endPoint={renderSearchEndPoint}
      onChange={(d) => onChange(d)}
      arrayBuilder={ArrayBuilder}
      value={value}
    />
  );
};

export default ServiceFormChildren1;
